import {
  selectIsFull,
  selectIsExternal,
} from 'state/environment/environmentSelectors';

export const selectIsCardSettingEnabled = (state, setting) =>
  selectIsFull(state) ||
  selectIsExternal(state) ||
  state.cardSetting.enabled.has(setting);
